import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'linkify'
})
export class LinkifyPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    // Regex to detect URLs (http, https, www)
    const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;

    return value.replace(urlRegex, (url) => {
      let hyperlink = url;
      if (!hyperlink.startsWith('http')) {
        hyperlink = 'https://' + hyperlink; // Ensure proper linking for "www." URLs
      }
      return `<a href="${hyperlink}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
  }
}
